import logoImage from './img/consultMidiaLogo.png';
import Routes from './routes';
import {useEffect} from "react";
import TagManager from "react-gtm-module";

function App() {
    useEffect(() => {
        let args = {
            gtmId: 'GTM-M8344CV',
        }
        TagManager.initialize(args);

    }, []);
    return (
        <>
            <div>
                <Routes/>
                <div className="d-none d-md-block">
                    <img className="img-fluid image" src={logoImage} alt="logo"/>
                </div>
            </div>
        </>
    );
}

export default App;
